import React from 'react'
import './shop.css'
const Shop = () => {
  return (
    <div className='Shop'>
      <div className="ShopType">
        
        <div className="ShopType1">
            <button className="ShopType1Btn">SHOP CLOTHING</button>
        </div>

        <div className="ShopType2">
            <button className="ShopType2Btn">SHOP ACCESSORIES</button>
        </div>

      </div>
    </div>
  )
}

export default Shop
